import api from './axios';

export const depositsAPI = {
  /**
   * GET /api/admin/deposits
   * @param {Object} params - search, status, from, to, page, per_page
   */
  getList: (params = {}) => api.get('/admin/deposits', { params }),

  /**
   * GET /api/admin/deposits/{id}
   */
  getById: (id) => api.get(`/admin/deposits/${id}`),

  /**
   * PUT /api/admin/deposits/{id}/status
   * @param {number} id
   * @param {{ status: 'approved'|'rejected', remarks?: string }} payload
   */
  updateStatus: (id, payload) => api.put(`/admin/deposits/${id}/status`, payload),
};
